import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CtaBand = ({ heading = "Tell us about the space.", copy }) => (
  <section data-testid="cta-band" className="dark-section bg-[#0A0A0A] text-white py-20 lg:py-28">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-y-10 lg:gap-x-10 items-end">
      <div className="col-span-12 lg:col-span-7">
        <div className="overline text-white/55">Start a project</div>
        <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]">
          {heading}
        </h2>
        {copy && <p className="mt-6 max-w-xl text-white/65 leading-relaxed">{copy}</p>}
      </div>
      <div className="col-span-12 lg:col-span-5 flex lg:justify-end">
        <Link
          to="/#contact"
          data-testid="cta-band-link"
          className="inline-flex items-center gap-2 px-7 py-4 text-sm font-medium bg-white text-[#0A0A0A] hover:bg-white/85 transition-colors"
        >
          Start a project <ArrowUpRight size={16} />
        </Link>
      </div>
    </div>
  </section>
);

export default CtaBand;
